import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "duplicate-small",
  "use": "duplicate-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"duplicate-small\">\n  <path d=\"M9 7H7V6h2V4h1v2h2v1h-2v2H9V7zm2 7H2V5h1V4H1v11h11v-2h-1v1zm4-13v11H4V1h11zm-1 1H5v9h9V2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol